var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pr-3",attrs:{"justify":"end"}},_vm._l((_vm.icons),function(ref,i){
var click = ref.click;
var color = ref.color;
var icon = ref.icon;
var to = ref.to;
var active = ref.active;
return _c('div',{key:i},[(click !== undefined && active)?_c('v-btn',{staticClass:"mx-1 mt-3",attrs:{"icon":"","color":color,"small":""},on:{"click":function($event){return _vm.onClick(click)}}},[_c('v-icon',{attrs:{"size":"28"}},[_vm._v(_vm._s(icon))])],1):(active)?_c('v-btn',{staticClass:"mx-1 mt-3",attrs:{"to":to,"icon":"","color":color,"small":"","bottom":""}},[_c('v-icon',{attrs:{"size":"28"}},[_vm._v(_vm._s(icon))])],1):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }